var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-form-element',{staticClass:"p-time-field"},[_c('p-text-field',_vm._g(_vm._b({ref:"textField",attrs:{"value":_vm.display,"color":_vm.computedColor}},'p-text-field',_vm.$props,false),Object.assign({}, _vm.$listeners,
      {input: _vm.onInput,
      blur: _vm.onBlur,
      focus: _vm.onFocus})))],1)}
var staticRenderFns = []

export { render, staticRenderFns }